import React from 'react';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';

function Privacy() {
  return (
    <div id="top">
      <div id="wrapper">
        <Header />
        <div id="navig_inside">
          <Navigation />
        </div>
        <div id="banner"></div>
        <div id="inside_page" className="bodyText">
          <div id="page1">
            <span className="bodyText">
              <p className="welcome_heading">Privacy Policy</p>
              <div className="clear"></div>
            </span>
            <div id="facil">
              <p><strong>Notice</strong><br />
                Please read these terms and conditions carefully. By accessing this site and any contents thereof, you agree to be bound by the terms and conditions listed exclusively for this site. If you do not agree to the terms and conditions below or have any reservations, do not access this site, or any contents thereof. The responsibility of anything conspiring hereafter will be on the sole discretion of the user. <br />
                <br />
                <strong>COPYRIGHT © 2013 INDIRA SHIVA RAO POLYTECHNIC</strong><br />
                Copyright in the pages and screens displaying the pages, and in the information and material therein and in their arrangement, is owned by INDIRA SHIVA RAO POLYTECHNIC unless otherwise indicated or agreed in writing.<br />
                <br />
                <strong>Use of Information and Materials</strong><br />
                The information and materials contained in this site and pages - and the terms, conditions, descriptions and the general layout that appear are subject to change. Not all advertised services are available in all geographic areas. Your eligibility for particular services is subject to final approval and action by the corporate offices of INDIRA SHIVA RAO POLYTECHNIC handled by its designated staff. <br />
                <br />
                <strong>Submissions </strong><br />
                All information submitted to INDIRA SHIVA RAO POLYTECHNIC via this site shall be deemed and remain the property of INDIRA SHIVA RAO POLYTECHNIC. The firm shall not be subject to any obligations of confidentiality regarding submitted information except as agreed by the INDIRA SHIVA RAO POLYTECHNIC entity, however INDIRA SHIVA RAO POLYTECHNIC will treat the information as material not subject to selling, sharing or renting with the exception of any direct request made by the Government of India or any of its bonafied subsidiary acting on its behalf.<strong><br />
                </strong></p>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Privacy;
